module.exports = __webpack_public_path__ + "vue-app/img/curve-bleu-big.cb039612.svg";